import { Component, Inject, Input, OnInit } from "@angular/core";
import { FeatureToggleService } from "@gtmhub/featureToggle";
import { FeatureFlag } from "@gtmhub/featureToggle/models";
import { IGtmhubRootScopeService } from "@gtmhub/models";
import { INotificationSettings } from "@gtmhub/notifications/models/notifications";
import { INotificationSettingsKeys, NotificationClass } from "@webapp/notification/models/notification-settings.model";

@Component({
  selector: "gh-notification-layout",
  templateUrl: "./notification-layout.component.html",
  styleUrls: ["./notification-layout.component.less"],
})
export class NotificationLayoutComponent implements OnInit {
  @Input()
  public notificationSettings: INotificationSettings;
  @Input()
  public notificationClass: NotificationClass;
  public isReflectionEnabled = false;

  public hasPermission: (permission: string) => boolean;
  public hasRole: (role: string) => boolean;
  public featureAvailable: (feature: string) => boolean;
  public notificationSettingsMap: INotificationSettingsKeys;

  constructor(@Inject("$rootScope") private rootScope: IGtmhubRootScopeService, private featureToggleService: FeatureToggleService) {}

  public ngOnInit(): void {
    this.hasPermission = (permission: string): boolean => this.rootScope.hasPermission(permission);
    this.hasRole = (role: string): boolean => this.rootScope.hasRole(role);
    this.featureAvailable = (feature: string): boolean => this.rootScope.featureAvailable(feature);

    this.notificationSettingsMap = {
      okrs: [
        {
          key: "okrsEditedByMe",
          titleKey: "updates_okrs_owned_by_me",
          isRestricted: this.hasRole("view-only"),
        },
        {
          key: "okrsEditedByTeam",
          titleKey: "updates_okrs_owned_by_my_team",
        },
        {
          key: "okrsAndTasksAssignedMeMyTeam",
          titleKey: "okrs_assigned_me_or_team",
        },
        {
          key: "objectiveApprovals",
          titleKey: "approval_workflow",
          isRestricted: this.hasRole("view-only"),
        },
      ],
      krs: [
        {
          key: "krProgressUpdateMe",
          titleKey: "owned_by_me",
          isRestricted: this.hasRole("view-only"),
        },
        {
          key: "krProgressUpdateTeam",
          titleKey: "owned_by_my_team",
        },
      ],
      kpis: [
        {
          key: "kpiAssignedMeMyTeam",
          titleKey: "kpis_assigned_to_me_or_my_team",
        },
      ],
      tasks: [
        {
          key: "taskAssignedMeMyTeam",
          titleKey: "tasks_assigned_me",
        },
      ],
      badges: [
        {
          key: "badges",
          titleKey: "badges_awarded_to_me_or_my_team",
        },
      ],
      mentionsInComments: [
        {
          key: "mentionsInComment",
          titleKey: "new_comments_and_mentions_and_reactions",
        },
      ],
    };

    this.featureToggleService.isFeatureAvailable(FeatureFlag.FeatureReflections).then((isReflectionEnabled) => {
      this.isReflectionEnabled = isReflectionEnabled;
      if (this.isReflectionEnabled) {
        this.notificationSettingsMap.reflections = [
          {
            key: "reflectionReminders",
            titleKey: "reflection_reminders",
          },
          {
            key: "reflectionsPublishedByTeammates",
            titleKey: "reflections_published_by_teammates",
          },
        ];
      }
    });
  }
}
